import React from 'react';
import Cookies from 'js-cookie';
import {cookieName} from './texts/utils';
import {UpgradeDialog} from './UpgradeDialog';
import {getServerTexts} from '../Announcement/data/texts';

export async function renderUpgradeDialog(root) {
    const upgradeDialogShown = Cookies.get(cookieName);
    await getServerTexts();
    if (upgradeDialogShown) {
        return null;
    }
    root.render(<UpgradeDialog />);
}
